module.exports = __webpack_public_path__ + "static/transports-in-japan-tokyo-islands-a1254c6c06d44fb2c1b8ffee6147d3af.jpg";